import React, { useContext } from 'react';
import { Card, Col, Input, Row } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';

// import '@ant-design/compatible/assets/index.css';


import UserContext from '../../../layout/UserContext';
import checkPermission from '../../../../components/Authorization/Util';

const { TextArea } = Input;

const Language = ({ formData, form, langCode, language, defaultLang }) => {
  const { t } = useTranslation(); 
  const { getFieldDecorator } = form;
  const value = useContext(UserContext);
  const disable = !checkPermission(value, 'appcms', 'write');

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    (<div>
      <Row>
        <Col span={18}>
          <Row>
            <Col span={24}>
              <Card bordered={false}>
                <Form.Item label={t('appCms.poi.fieldTitle')}>
                  {getFieldDecorator('title-' + langCode, {
                    rules: defaultLang
                      ? [
                          {
                            required: true,
                            message: t('appCms.poi.titleRequired'),
                          },
                        ]
                      : [],
                    initialValue: formData ? formData.title : undefined,
                  })(
                    <Input
                      disabled={disable}
                      className={
                        language.directionRightToLeft ? 'rightToLeftText' : ''
                      }
                    />,
                  )}
                </Form.Item>

                <Form.Item label={t('appCms.poi.description')}>
                  {getFieldDecorator('description-' + langCode, {
                    rules: defaultLang
                      ? [
                          {
                            required: true,
                            message: t('appCms.poi.descriptionRequired'),
                          },
                        ]
                      : [],
                    initialValue: formData ? formData.description : undefined,
                  })(
                    <TextArea
                      rows={10}
                      showCount
                      maxLength={2000}
                      disabled={disable}
                      className={
                        language.directionRightToLeft ? 'rightToLeftText' : ''
                      }
                    />,
                  )}
                </Form.Item>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>)
  );
};

Language.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  formData: PropTypes.object,
  langCode: PropTypes.string,
  language: PropTypes.object,
  defaultLang: PropTypes.string,
};

Language.contextType = UserContext;

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(Language);
